/**** mgt.District */
import { apiTypes } from 'shared/consts/handbooksApiTypes';

const config = {
  schema: 'mgt',
  table: 'District',
  title: 'Муниципальные районы',
  apiType: apiTypes.DEFAULT,
  elemsOnPage: 100,
  fields: [
    {
      name: 'district_id',
      title: 'ID записи',
      index: true,
      type: 'number',
      width: '120px',
    },
    {
      name: 'district_code',
      title: 'Код ОКАТО',
      type: 'text',
      required: true
    },
    {
      name: 'district_name',
      title: 'Наименование',
      type: 'text',
      required: true,
    },
    {
      name: 'geom',
      title: 'Зона',
      type: 'polygon',
      required: true,
      disableFilter: true,
    }
  ],
  newTemplate: {
    district_id: null,
    district_code: '',
    district_name: '',
    geom: null
  },
  createField: 'createdAt',
  updateField: 'updatedAt',
  makeIdOnInsert: true,
  defaultSort: {
    field: 'district_id',
    direction: 'desc',
  },
  import: {
    header: [
      {
        title: 'district_id',
        field: 'district_id',
      },{
        title: 'district_code',
        field: 'district_code',
      },{
        title: 'district_name',
        field: 'district_name',
      },{
        title: 'geom',
        field: 'geom',
      }
    ],
    example: `1;123;Название;0103000020E61000000100000005000000010000009A743E40E478A3D4B4F54D4000000000484E3E402E1000EF35F14D40010000006E373E40B194C3CD7FF64D40000000003D4A3E4011259C167FFD4D40010000009A743E40E478A3D4B4F54D40`,
  }

};

export default config;